import { BsyUtils } from "./Utils";

export const ImageAddWatermark = function (file, watermarkConfig) {

  const fileMime = file.type;

  function CalculateCanvasTextWidth(text, width, draw_width, ctx) {
    const textList = [];
    let str = "";
    const tL = text.split("");
    if (width <= draw_width) {
      textList.push(text);
    } else {
      for (let l = 0; l < tL.length; l += 1) {
        str += tL[l];
        if (ctx.measureText(str).width > draw_width) {
          textList.push(str.substr(0, str.length - 1));
          str = tL[l];
        }
        if (l === tL.length - 1) {
          textList.push(str);
        }
      }
    }
    return textList;
  }

  return new Promise((resolve, reject) => {
    var fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    var img = new Image();
    fileReader.onload = function () {
      img.onload = () => {
        const { content, color, location } = watermarkConfig;
        const h = img.height;
        const w = img.width;

        // 经测试，当图片像素大于 2000W的时候，canvas会出现异常
        if (w * h > 1000 * 20000) {
          resolve(file);
        } else {
          const canvas = Object.assign(document.createElement("canvas"), {
            width: w,
            height: h,
          });
          const ctx = canvas.getContext("2d");
          let pos = [canvas.width, canvas.height];
          let size = canvas.width * 0.035;
          if (canvas.width > canvas.height) {
            size = canvas.height * 0.035;
          }

          if (size <= 10) {
            size = 10;
          }
          canvas.style.backgroundColor = "transparent";
          const font = `normal ${size}px Microsoft YaHei`;
          ctx.drawImage(img, 0, 0);
          ctx.font = font;
          ctx.wordSpacing = "2px";
          ctx.letterSpacing = `${size / 10}px`;
          ctx.fontKerning = "normal";
          ctx.shadowOffsetX = 1; // 用来设定阴影在 X轴的延伸距
          ctx.shadowOffsetY = 1; // 用来设定阴影在 Y轴的延伸距
          ctx.shadowBlur = 3; // 设定阴影的模糊程度 默认0
          ctx.shadowColor = "rgba(0, 0, 0, 0.4)"; // 设定阴影颜色效果
          ctx.fillStyle = color; // BsyUtils.hexToRGBAStr(color, 0.5);
          let align = "left";
          let draw_width = canvas.width * 0.5;

          if (watermarkConfig?.location === "center") {
            pos = [canvas.width / 2, canvas.height / 2];
            draw_width = canvas.width * 0.8;
          }

          let startX = pos[0];
          const startY = pos[1];
          let startpoint = startY;
          const steps = size + size / 2.8;
          let textHeight = 0;
          const textCont = [];
          let textWidth = 0;
          const textWidthList = [];

          for (let l = 0; l < content.length; l += 1) {
            const str = content[l] + '';
            const tWidth = ctx.measureText(str).width;
            const sL = CalculateCanvasTextWidth(str, tWidth, draw_width, ctx);
            // 首先绘制需要上传至服务器的图
            for (let s = 0; s < sL.length; s += 1) {
              textHeight += steps;
              textWidthList.push(ctx.measureText(sL[s]).width);
              textCont.push(sL[s]);
            }
          }

          textWidth = Math.max(...textWidthList);
          const imgPadding = Math.min(startX * 0.01, startY * 0.01);

          if (location === "topLeft") {
            align = "left";
            startpoint = size + imgPadding;
            startX = imgPadding;
          } else if (location === "bottomLeft") {
            align = "left";
            startpoint = startY - textHeight + size - imgPadding;
            startX = imgPadding;
          } else if (location === "topRight") {
            align = "right";
            startX = canvas.width - textWidth;
            startpoint = size + imgPadding;
          } else if (location === "bottomRight") {
            align = "right";
            startX = canvas.width - textWidth;
            startpoint = startY - textHeight + size - imgPadding;
          } else if (location === "center") {
            align = "left";
            startX -= textWidth / 2;
            startpoint = startY - textHeight / 2 + size / 2;
          } else if (location === "full") {
            align = "left";
            startX = imgPadding;
            startpoint = size + imgPadding;
          }

          const xCount = Math.ceil((canvas.width / textWidth) * 2); // 计算水印文本需要重复多少次才能覆盖整个画布
          const yCount = Math.ceil((canvas.height / textHeight) * 2);
          if (location === "full") {
            ctx.translate(0, canvas.height / 2); // 将画布中心点移动到画布中心
            ctx.rotate(-Math.PI / 4); // 旋转45度
            for (let i = 0; i < yCount; i += 1) {
              for (let j = 0; j < xCount; j += 1) {
                const x =
                  j * textWidth -
                  (xCount * textWidth) / 4 +
                  Math.max(j * (textWidth / 6), 10);
                let y = i * textHeight - (yCount * textHeight) / 4 + steps * i;
                for (let s = 0; s < textCont.length; s += 1) {
                  ctx.textAlign = align;
                  ctx.fillText(textCont[s], x, y);
                  y += steps;
                }
              }
            }
          } else {
            for (let s = 0; s < textCont.length; s += 1) {
              ctx.textAlign = align;
              ctx.fillText(textCont[s], startX, startpoint);
              startpoint += steps;
            }
          }
          ctx.save();
          const imgData = canvas.toDataURL(fileMime, 0.65);
          resolve(BsyUtils.dataURLtoFile(imgData, file.name));
        }
      };
      img.src = fileReader.result;
    };
  });
};
